type JetBrainsLogoProps = React.SVGProps<SVGSVGElement>

export const JetBrainsLogo = (props: JetBrainsLogoProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" focusable="false" aria-label="JetBrains icon" {...props}>
    <g clipPath="url(#clip0_8288_131884)">
      <path
        d="M11.4121 2.14652L2.55082 11.0078C1.3077 12.2509 0.606445 13.9403 0.606445 15.704V31.5459C0.606445 33.0121 1.79645 34.2021 3.2627 34.2021H19.1046C20.8683 34.2021 22.5524 33.5009 23.8008 32.2578L32.6621 23.3965C33.9052 22.1534 34.6064 20.464 34.6064 18.7003V2.8584C34.6064 1.39215 33.4164 0.202148 31.9502 0.202148H16.1083C14.3446 0.202148 12.6605 0.903399 11.4121 2.14652Z"
        fill="url(#paint0_linear_8288_131884)"
      />
      <path d="M26.1064 8.70215H4.85645V29.9521H26.1064V8.70215Z" fill="black" />
      <path d="M16.5439 25.1709H7.5127V27.2959H16.5439V25.1709Z" fill="white" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_8288_131884"
        x1="1.05801"
        y1="33.5221"
        x2="33.8733"
        y2="1.16371"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9419" />
        <stop offset="0.43" stopColor="#FF021D" />
        <stop offset="0.99" stopColor="#E600FF" />
      </linearGradient>
      <clipPath id="clip0_8288_131884">
        <rect width="34" height="34" fill="white" transform="translate(0.606445 0.202148)" />
      </clipPath>
    </defs>
  </svg>
)

try{ JetBrainsLogo.displayName ||= 'JetBrainsLogo' } catch {}